export const getTableSchema = (t, currencyCode) => {
  return [
    {
      id: 'quantity',
      label: t('SSRO_QUANTITY'),
      width: '10%',
      className: 'd-none d-md-table-cell text-center p-2',
      hideOnMobile: true
    },
    {
      id: 'thumbnail',
      width: '12%',
      isSortable: false,
      className: 'p-2 d-md-table-cell'
    },
    {
      id: 'name',
      width: '24%',
      label: t('ITEMNAME_PARTNUMBER'),
      isSortable: false,
      className: 'p-2 text-start d-md-table-cell'
    },
    {
      id: 'availability',
      label: t('AVAILABILITY'),
      isSortable: false,
      width: '14%',
      className: 'text-center d-none d-md-table-cell p-2',
      hideOnMobile: true
    },
    {
      id: 'price',
      label: (
        <>
          <span className="color-dark-gray text-univers--bold u-fs--14">
            {`${t('TOTAL_PRICE')} `}
          </span>
          <span className="color-dark-gray text-univers">{`(${currencyCode})`}</span>
        </>
      ),
      isSortable: false,
      width: '18%',
      className: 'text-end d-none d-md-table-cell p-2',
      hideOnMobile: true
    },
    {
      id: 'addtocart',
      className: 'd-none d-md-table-cell text-center p-0',
      width: '17%',
      hideOnMobile: true
    },
    {
      id: 'carticon',
      className: 'd-none d-md-table-cell p-0',
      width: '5%',
      hideOnMobile: true
    }
  ];
};
